import { render, staticRenderFns } from "./AuthResetLink.vue?vue&type=template&id=5ecf0b17&lang=pug&"
import script from "./AuthResetLink.vue?vue&type=script&lang=js&"
export * from "./AuthResetLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports